var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ObjectWidget as _ObjectWidget } from '../angular2-schema-form-shim';
import { isWidgetRequired } from './overrides';
var ObjectWidget = (function (_super) {
    __extends(ObjectWidget, _super);
    function ObjectWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ObjectWidget.prototype.isPropertyVisible = function (path) {
        return this.formProperty.getProperty(path).visible;
    };
    Object.defineProperty(ObjectWidget.prototype, "required", {
        get: function () {
            return isWidgetRequired(this);
        },
        enumerable: true,
        configurable: true
    });
    return ObjectWidget;
}(_ObjectWidget));
export { ObjectWidget };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/object.widget.ts.pre-build-optimizer.js